import React from 'react'
import { useNavigate } from 'react-router-dom';

const BookNowButton = () => {
    const navigate = useNavigate();

    return (
        <button
            onClick={() => navigate('/contact')}
            className="bg-yellow-600 hover:bg-yellow-500 text-black font-bold py-4 px-12 rounded-lg transition-colors duration-200 shadow-lg"
        >
            Book Now
        </button>
    );
}

export default BookNowButton;